import React from 'react';
import moment from 'moment';
import { Link } from 'react-router-dom'

import Upload from './header/Upload';
import MessageCenterHeaderNavigation from './header/MessageCenterHeaderNavigation';
import User from './header/User';

class WorkspaceHeader extends React.Component {

    navToggle () {
        this.props.navToggle(!this.props.navExpanded)
    }

    render () {
        var nav;

        if (!this.props.landing) {
            var clientTZ = moment.tz(this.props.credentials.client.timeZone)
            var clientTZabbr = clientTZ.format("z");
            var offset = clientTZ.utcOffset() / 60;
            nav = (<div id="header-desktop">
                <ul className="nav navbar-nav navbar-right">

                    <li id="clientid-display">
                        Client ID: {this.props.clientID} | Timezone: {clientTZabbr} (UTC {offset})
                    </li>

                    <Upload
                        api={this.props.api}
                        open={this.props.uploadModal}
                        uploadFn={this.props.upload}
                        uploadEventID={this.props.uploadEventID}
                        onClose={this.props.onUploadModalClose}
                        onOpen={this.props.onUploadModalOpen}
                        emitSnack={this.props.emitSnack}
                    />

                    <MessageCenterHeaderNavigation
                        totalUnread={this.props.unreadMessagesCount}
                        toggleMessageCenter={this.props.toggleMessageCenter}
                    />

                    <User email={this.props.email} />

                </ul>
            </div>);

            return (
                <nav id="workspace-header" className="navbar navbar-fixed-top hidden-print">

                    <button type="button" className="navbar-toggle" 
                        onClick={()=>this.navToggle()}
                    >
                        <span className="sr-only">Toggle navigation</span>
                        <span className="icon-bar icon-bar-1"></span>
                        <span className="icon-bar icon-bar-2"></span>
                        <span className="icon-bar icon-bar-3"></span>
                    </button>

                    <Link className="navbar-brand" to="/">
                        <img src="/dist/img/logo-grey.svg" alt="Invintus Media" />
                    </Link>

                    {nav}


                    {this.props.children}

                </nav>
            );
        }

        // Landing only shows the icon
        return (

            <nav id="workspace-header" className="navbar navbar-fixed-top hidden-print">
                <Link className="navbar-brand" to="/">
                    <img src="/dist/img/logo-grey.svg" alt="Invintus Media" />
                </Link>
            </nav>
        );
    }
}

export default WorkspaceHeader;
